export default {
  auto: ['actions'],
}
